import React from 'react';
import TopMenu from './TopMenu';

const Header = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '0',
      }}
    >
      <TopMenu />
    </div>
  );
};

export default Header;